/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { updateCampaignDataStatusSchema } from './UpdateCampaignDataStatusSchema'

export const updateCampaignDataSchema = z.object({
	id: z.string().uuid().nullable().optional(),
	title: z.string().nullable().optional(),
	language: z.string().nullable().optional(),
	requirements: z.string().nullable().optional(),
	notes: z.string().nullable().optional(),
	status: updateCampaignDataStatusSchema.nullable().optional(),
	budget: z.number().nullable().optional(),
	location: z.string().nullable().optional(),
	audience: z.string().nullable().optional(),
	branding: z.object({
		id: z.string().uuid().nullable().optional(),
		organisationId: z.string().nullable().optional(),
		name: z.string().nullable().optional(),
		website: z.string().url().nullable().optional(),
		logoId: z.string().uuid().nullable().optional(),
		toneOfVoice: z.string().nullable().optional(),
		visualGuidance: z.string().nullable().optional(),
		cornerRadius: z.string().nullable().optional(),
		background: z.string().nullable().optional(),
		foreground: z.string().nullable().optional(),
		accentBackground: z.string().nullable().optional(),
		accentForeground: z.string().nullable().optional(),
		fonts: z.object({ title: z.string().nullable(), body: z.string().nullable() }).nullable().optional(),
		meta: z.record(z.string(), z.unknown()).nullable().optional(),
		generateKeyImage: z.boolean().nullable().optional(),
	}).nullable().optional(),
	brandingId: z.string().uuid().nullable().optional(),
	sourceWebsite: z.string().nullable().optional(),
	meta: z.record(z.string(), z.unknown()).nullable().optional(),
	adCampaignLocations: z.array(
		z.object({
			id: z.string(),
			name: z.string(),
			country: z.object({ id: z.string(), name: z.string() }),
			region: z.object({ id: z.string().optional(), name: z.string().optional() }).nullable(),
			radius: z.number().optional(),
		}),
	).nullable().optional(),
	startDate: z.iso.datetime().nullable().optional(),
	endDate: z.iso.datetime().nullable().optional(),
	customFields: z.array(z.object({ id: z.string(), value: z.string() })).optional(),
	channels: z.array(z.union([z.literal('meta'), z.literal('career_site')])).nullable().optional(),
})

export type UpdateCampaignDataSchema = z.infer<typeof updateCampaignDataSchema>
